const TextComponent: React.FC<Props> = (props) => {
    const { text } = props;

    if (text) {
        return (
            <>
                {text.split('\n').map((line) => {
                    return (
                        <>
                            {line}
                            <br />
                        </>
                    );
                })}
            </>
        );
    } else {
        return <></>;
    }
};
export default TextComponent;

interface Props {
    text: string | undefined;
}
